export default "__VITE_ASSET__CIKAgxG7__"